import styles from "./PoolsDisplay.module.css";
import { uniDefaultTokenList } from "../../../../../data/tokens";
import { AiOutlineArrowDown} from "react-icons/ai"

import PoolsCard from "../PoolsCard/PoolsCard";
const PoolsDisplay = () => {


  
  
  // This is a function to create pair tokens from the tokens for the pool display .
const splitPairs = function(arr) {
  const pairs = [];
  for (let i=0 ; i<arr.length ; i+=2) {
      if (arr[i+1] !== undefined) {
          pairs.push ([arr[i], arr[i+1]]);
      } else {
          pairs.push ([arr[i]]);
      }
  }
  return pairs;
};
  
  
  const TempPairs = splitPairs(uniDefaultTokenList.tokens)

  const AllPoolsDisplay = TempPairs.map((pair, idx) => (
    <PoolsCard pair={pair} idx={ idx}/>
))


  const TopTokensHeader = (
    <div className={styles.top_tokens_header}>
      <span className={styles.token_number}>#</span>
      <span className={styles.title_name}>Pool</span>
      <span className={styles.title_tvl}>TVL <AiOutlineArrowDown  size={15} /></span>
      <span className={styles.title_volume}>Volume 24H</span>
      <span className={styles.title_price}>Volume 7D</span>
      {/* <span className={styles.title_price_change}>Price Change</span> */}
    </div>
  );

  const watchList = (
    <div>
      <span>Your Watchlist</span>
      <div className={styles.watchlist_container}>
        <div className={styles.watchlist_placeholder}>
          Tokens on you watchlist will appear here
        </div>
      </div>
    </div>
  );


  const topMovers = (
    <div className={styles.top_movers_container}>
    <div className={styles.top_movers_content}>
        <span className={styles.top_movers_title}>Top Movers</span>
        <div className={styles.top_movers_content_container}>
            <div className={styles.top_movers_content_container_content} id="flavoursContainer">
                {/* {TopMoversDisplay} */}
            </div>
        </div>
    </div>
</div>
  )

  return (
    <div className={styles.crypto_page}>
      <div className={styles.crypto_container}>
        <div className={styles.crypto_content}>
          {watchList}
    {/* {topMovers} */}
          <span>All Pools</span>
          <div className={styles.top_tokens_container}>
            <div className={styles.top_tokens_content}>
              {TopTokensHeader}
              <span className={styles.advisor}></span>
              {AllPoolsDisplay}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PoolsDisplay;
